import { createCompassModalSwitcher } from "@circle-react/components/SettingsApp/CompassCompat/createCompassModalSwitcher";

import { EditSpaceGroupModalComponent } from "./EditSpaceGroupModalComponent";
import { EditSpaceGroupModalUIKitComponent } from "./EditSpaceGroupModalUIKitComponent";

export const useEditSpaceGroupModal = createCompassModalSwitcher(
  EditSpaceGroupModalComponent,
  EditSpaceGroupModalUIKitComponent,
  { removeOnClose: true },
);
